export default {
  ERROR: "alert alert-danger",
};
